"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var CheckCircle = function CheckCircle(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/nav/check_circle-check-circle" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    fillRule: "nonzero",
    id: "grey600-check-circle" + unique,
    xlinkHref: "#path-1-check-circle" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-check-circle" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,2 C17.52,2 22,6.48 22,12 C22,17.52 17.52,22 12,22 C6.48,22 2,17.52 2,12 C2,6.48 6.48,2 12,2 Z M9.94216556,14.1977358 L6.9226205,11.1525253 C6.72818642,10.9564385 6.41160677,10.9550988 6.21552005,11.1495329 L5.49885242,11.8601603 C5.30535225,12.0520297 5.30112295,12.3635113 5.48934233,12.5605636 L9.40713257,16.6622118 C9.40977142,16.6649745 9.41244184,16.6677068 9.41514332,16.6704083 C9.61040546,16.8656705 9.92698795,16.8656705 10.1222501,16.6704083 L18.2857282,8.50693024 C18.4809903,8.31166809 18.4809903,7.9950856 18.2857282,7.79982346 L17.5828597,7.09695498 C17.5814554,7.09555064 17.5800427,7.09415468 17.5786217,7.09276718 C17.3810467,6.89984562 17.0644867,6.90361797 16.8715651,7.10119298 L9.94216556,14.1977358 Z",
    fill: "inherit",
    id: "path-1-check-circle" + unique
  }))));
};

CheckCircle.propTypes = propTypes;
var _default = CheckCircle;
exports["default"] = _default;